import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material/";
import auth from "../services/auth";
import api from "../services/api";

const defaultValues = {
  name: "",
  user_id: 0,
  fire_email: false,
  sub_category: 0,
};

export default function ModalCategoryForm(props) {
  const {
    openCategoryModal,
    handleClose,
    userId,
    setState,
    category,
    categories,
  } = props;
  const [values, setValues] = useState(defaultValues);

  useEffect(() => {
    if (category) {
      setValues(category);
    }else{
      setValues({ ...values, user_id: userId });
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const method = category ? "put" : "post";
    const link = category ? `categories/${category.id}` : "categories";

    console.log(method, link);

    api[method](link, values, { headers: auth.token() })
      .then((response) => {
        if (response.status === 201) {
          setState((prev) => !prev);
          handleClose();
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  const onChange = (ev) => {
    const { name, value, checked } = ev.target;
    if (name === "fire_email") {
      setValues({ ...values, [name]: checked ? 1 : 0 });
    }else{
      setValues({ ...values, [name]: value });
    }
    console.log(values)
  };

  return (
    <Dialog
      onSubmit={handleSubmit}
      component="form"
      maxWidth="sm"
      open={openCategoryModal}
      onClose={handleClose}
    >
      <DialogTitle>
        {category ? "Editar Categoria" : "Nova Categoria"}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              autoFocus
              required
              value={values.name}
              onChange={onChange}
              margin="dense"
              id="name"
              name="name"
              label="Nome"
              type="text"
              fullWidth
              variant="standard"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={values.fire_email?true:false}
                  id="fire-email"
                  name="fire_email"
                  onChange={onChange}
                  color="primary"
                />
              }
              label="Envio de e-mail"
              labelPlacement="top"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="sub_category">Subcategoria</InputLabel>
              <Select
                value={values.sub_category ? values.sub_category : 0}
                onChange={onChange}
                id="sub_category"
                name="sub_category"
                label="SubCategoria"
              >
                <MenuItem value={0}>Sem subcategoria</MenuItem>
                {categories &&
                  categories.map((value) => (
                    <MenuItem key={value.id} value={value.id}>
                      {value.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" type="submit">
          {category ? "Editar" : "Cadastrar"}
        </Button>
        <Button onClick={handleClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
}
